export default {
  image: [
    'jpg',
    'png',
    'jpeg',
  ],
  audio: [
    'mp3',
    'wav',
  ],
  code: [
    'js',
    'jsx',
    'css'
  ],
  video: [
    'mp4',
    'mpeg4',
  ],
  previewable: {
    image: [
      'jpg',
      'png',
      'jpeg',
    ],
    audio: [
      'mp3',
    ],
    pdf: [
      'pdf',
    ],
    video: [
      'mp4',
      'mpeg4',
    ],
    special: [
      'doc',
      'docx'
    ]
  }
}